// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"2e8640a5cd18b011fc12","883":"a8c074378fc61ddfe04a"}[chunkId] + ".js";
};